import Header from '../../../shared/Header/Header';
import Footer from '../../../shared/Footer/Footer';
import SectionHeader from '../../../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import BackButton from '../../../shared/backButton/BackButton';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
import useIsLTE650 from '../../../../hooks/useIsLTE650';
import './loyaltyPage.scss';

const LoyaltyPage: React.FC = () => {
    const isMobile = useIsLTE650(650);

    return (
        <div className="loyaltyPage">
            <Header isMobile={isMobile} />
            <div className="loyaltyPage_headerWrapper">
                <BackButton absolute />
                <SectionHeader title={'Бонусная программа'} />
            </div>
            <SectionBody>
                <>
                    <p className="loyaltyPage__subTitle">С. Габай</p>
                    <h2 className="loyaltyPage__title">Программа лояльности</h2>
                    <p className="loyaltyPage__text">
                        Наша компания создала для Вас программу лояльности для Вашего удобства и максимальной выгоды. Копите бонусы и получайте возможность
                        побаловать себя нашей прекрасной продукцией!
                    </p>
                    <div className={`loyaltyPage-loyaltyCard loyaltyPage-loyaltyCard-background-silver`}>
                        <div className="loyaltyPage-loyaltyCard-front">
                            <img src="/logo.png" alt="С.Габай" className="loyaltyPage-loyaltyCard-logo" />
                            <div className="loyaltyPage-loyaltyCard-number">0000 0000 0000 0000</div>
                            <div className="loyaltyPage-loyaltyCard-support">Служба поддержки +7 (495) 280-60-55</div>
                        </div>
                    </div>
                    <p style={{ textAlign: 'center' }} className="loyaltyPage__text">
                        1 БОНУС =1 РУБЛЬ
                    </p>
                    <h3 style={{ textAlign: 'center' }} className="loyaltyPage-subtitle">
                        КАК СТАТЬ УЧАСТНИКОМ БОНУСНОЙ ПРОГРАММЫ?
                    </h3>
                    <ul className="loyaltyPage-list">
                        <li>Зарегистрируйтесь в личном кабинете</li>
                        <li>После покупки получите бонусы на бонусный счет</li>
                        <li>Бонусами можно оплатить до 30% покупки</li>
                        <li>Накопление бонусов происходит автоматически после оформления заказа и оплаты товара в соответствии со статусом Вашей карты</li>
                        <li>Бонусы активируются через 14 дней с момента их начисления и с этого момента могут быть использованы</li>
                        <li>
                            Для всех участников программы лояльности мы регулярно формируем индивидуальные предложения, которые заинтересуют Вас и сделают покупки
                            максимально выгодными.
                        </li>

                        <li>
                            Возвращаем <b>3%</b> от общей суммы покупки бонусом на карту при сумме покупок <b>до 99 999 руб. ( базовый уровень)</b>
                        </li>
                        <li>
                            Возвращаем <b>5%</b> от общей суммы покупки бонусом на карту при сумме покупок <b>от 100 000 до 499 999 руб. (серебряный уровень)</b>
                        </li>
                        <li>
                            Возвращаем <b>10%</b> от общей суммы покупки бонусом на карту при сумме покупок <b>от 500 000 руб. до 999 999 руб. (золотой уровень)</b>
                        </li>
                        <li>
                            Возвращаем <b>15%</b> от общей суммы покупки бонусом на карту при сумме покупок{' '}
                            <b>
                                от 1 000 000 руб. ( VIP уровень).<br></br>Возможны индивидуальные условия.
                            </b>
                        </li>
                        <li>
                            Скидка применяется только к товарам по полной стоимости, и не суммируется с другими акциями и предложениями. Бонусы не начисляются на
                            товары, купленные со скидкой и по специальной акционной цене.
                        </li>
                        <li>За одну операцию Вы можете выбрать одно из действий: накопить бонусы или использовать бонусы для оплаты.</li>
                        {/* <li style={{ color: 'red' }} title="Не реализовано">
                            При приобретении подарочных карт и электронных подарочных сертификатов бонусы не начисляются. Вы можете приобрести подарочные карты
                            номиналом в 5000/10000/20000/25000/30000/50000 рублей. Подарочные карты электронные, обмену и возврату не подлежат. Суммы, не
                            использованные на карте, возврату не подлежат.
                        </li>
                        <li style={{ color: 'red' }} title="Не реализовано">
                            За товары, оплаченные подарочной картой, бонусы начисляются согласно уровню карты лояльности плательщика в личном кабинете.
                        </li> */}
                        <li>Перенос бонусов с вашей карты на карту другого клиента невозможен.</li>
                        <li>Бонусы действуют в течение 1 года с момента начисления.</li>
                        <li>При оплате товара по счету бонусы будут начислены через 14 дней со дня доставки.</li>
                        <li>
                            При возврате товара, полностью или частично оплаченного бонусами, бонусы будут восстановлены на карте лояльности в соответствии со сроком
                            активности бонусов.
                        </li>
                        <li>
                            В честь <b>Дня рождения</b> предоставляется скидка <b>25%</b> на весь каталог по полной цене изделий на 1 заказ. Предложение не
                            суммируется с другими действующими скидками и акциями. Дата дня рождения при такой операции должна быть указана в личном кабинете не
                            позднее чем за две недели до даты Дня рождения. Предложение действует 7 дней до Дня рождения и 7 дней после Дня Рождения.
                        </li>
                    </ul>
                    <p style={{ textAlign: 'center' }} className="loyaltyPage__text">
                        Компания оставляет за собой право менять условия программы лояльности без согласия клиентов и их дополнительного информирования.
                    </p>
                </>
            </SectionBody>
            <Footer isMobile={isMobile} />
        </div>
    );
};

export default LoyaltyPage;
